
import { useEffect, useMemo, useState } from 'react';
import { Dimensions } from 'react-native';
import { BREAKPOINT_CONFIG, BreakpointConfigs } from './breakpointConfig';

type Bucket = 'sm' | 'md' | 'lg';

function getBreakpoint(width: number, bp: { sm: number; md: number }): Bucket {
  if (width >= bp.md) return 'lg';
  if (width <= bp.sm) return 'sm';
  return 'md';
}

function useBreakpoint(breakpoints: { sm: number; md: number }): Bucket {
  const initial = useMemo(
    () => getBreakpoint(Dimensions.get('window').width, breakpoints),
    [breakpoints],
  );

  const [breakpoint, setBreakpoint] = useState<Bucket>(initial);

  // If the breakpoints definitions change, recalculate and update the current breakpoint
  useEffect(
    () => { setBreakpoint(initial) },
    [initial]
  )

  useEffect(
    () => {
      const sub = Dimensions.addEventListener(
        'change',
        ({ window }) => {
          const next = getBreakpoint(window.width, breakpoints)
          setBreakpoint(prev => prev === next ? prev : next)
        });

      return sub?.remove
    },
    [breakpoint]
  );

  return breakpoint;
}

export const useBreakpointValue = (componentKey: BreakpointConfigs) => {
  const config = BREAKPOINT_CONFIG[componentKey];
  if (!config) {
    throw new Error(`No breakpoint configuration found for component: ${componentKey}`);
  }

  const { breakpoints, values } = config;
  const breakpoint = useBreakpoint(breakpoints);

  return values[breakpoint];
};
